const initSidebar = () => {
    var _a;
    //only in blog for now
    if (document.querySelector(".blog")) {
        //get sidebar
        const sidebarComponent = (_a = document.querySelector("[data-sidebar]")) === null || _a === void 0 ? void 0 : _a.parentElement;
        //if there is a sidebar in page and we are below the ipad classic width
        if (sidebarComponent && window.innerWidth <= 767) {
            //clone node and its children recursively
            const sidebarClone = sidebarComponent.cloneNode(true);
            //add class cloned
            sidebarClone.classList.add("cloned");
            //set data attribute to activate toggle
            sidebarClone.setAttribute("data-to-be-toggled", "mobile-sidebar");
            //append to body
            document.body.appendChild(sidebarClone);
            initToggler("mobile-sidebar");
        }
    }
};
